class Wishlist {
  constructor() {
    this.storageKey = 'pure_enso_wishlist';
    this.wishlist = this.getWishlist();
    this.init();
  }

  getWishlist() {
    const list = localStorage.getItem(this.storageKey);
    return list ? JSON.parse(list) : [];
  }

  saveWishlist() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.wishlist));
    this.updateHeaderBadge();
    this.updateButtons();
    // Dispatch custom event so other scripts can listen if needed
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: this.wishlist }));
  }

  toggle(handle) {
    if (this.wishlist.includes(handle)) {
      this.wishlist = this.wishlist.filter(item => item !== handle);
    } else {
      this.wishlist.push(handle);
    }
    this.saveWishlist();
  }

  updateHeaderBadge() {
    const badges = document.querySelectorAll('.wishlist-count-bubble span[aria-hidden="true"]');
    const bubbleContainers = document.querySelectorAll('.wishlist-count-bubble');
    
    if (this.wishlist.length > 0) {
      badges.forEach(badge => badge.textContent = this.wishlist.length);
      bubbleContainers.forEach(container => container.classList.remove('hidden'));
    } else {
      bubbleContainers.forEach(container => container.classList.add('hidden'));
    }
  }

  updateButtons() {
    const buttons = document.querySelectorAll('.wishlist-btn');
    buttons.forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (this.wishlist.includes(handle)) {
        btn.classList.add('wishlist-btn--active');
      } else {
        btn.classList.remove('wishlist-btn--active');
      }
    });
  }

  init() {
    this.updateHeaderBadge();
    this.updateButtons();

    // Event delegation for wishlist buttons using capture phase
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.wishlist-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        const handle = btn.dataset.productHandle;
        if (handle) {
          this.toggle(handle);
        }
      }
    }, true);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.ShopifyWishlist = new Wishlist();
});
